{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Пользовательские атрибуты",
    "HEADER_BTN_TXT": "Добавить пользовательский атрибут",
    "LOADING": "Получение пользовательских атрибутов",
    "DESCRIPTION": "Пользовательский атрибут отслеживает дополнительную информацию о ваших контактах или разговорах, таких как план подписки или дата их первой покупки. Вы можете добавить различные типы пользовательских атрибутов, такие как текст, списки или цифры, чтобы захватить нужную вам информацию.",
    "LEARN_MORE": "Узнайте больше о пользовательских атрибутах",
    "COUNT": "{n} атрибут | {n} атрибутов",
    "SEARCH_PLACEHOLDER": "Поиск по атрибутам...",
    "NO_RESULTS": "Не найдено атрибутов, соответствующих вашему запросу",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Диалог",
      "CONTACT": "Контакт",
      "COMPANY": "Компания"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Текст",
      "NUMBER": "Число",
      "LINK": "Ссылка",
      "DATE": "Дата",
      "LIST": "Список",
      "CHECKBOX": "Флажок"
    },
    "ADD": {
      "TITLE": "Добавить пользовательский атрибут",
      "SUBMIT": "Создать",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "NAME": {
          "LABEL": "Отображаемое имя",
          "PLACEHOLDER": "Введите отображаемое имя пользовательского атрибута",
          "ERROR": "Необходимо указать имя"
        },
        "DESC": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Введите описание пользовательского атрибута",
          "ERROR": "Необходимо описание"
        },
        "MODEL": {
          "LABEL": "Применить к",
          "PLACEHOLDER": "Пожалуйста, выберите один",
          "ERROR": "Необходимо указать модель"
        },
        "TYPE": {
          "LABEL": "Тип",
          "PLACEHOLDER": "Пожалуйста выберите тип",
          "ERROR": "Необходимо указать тип",
          "LIST": {
            "LABEL": "Список значений",
            "PLACEHOLDER": "Пожалуйста, введите значение и нажмите клавишу Enter",
            "ERROR": "Должно быть хотя бы одно значение"
          }
        },
        "KEY": {
          "LABEL": "Ключ",
          "PLACEHOLDER": "Введите ключ пользовательского атрибута",
          "ERROR": "Необходимо указать ключ",
          "IN_VALID": "Неверный ключ"
        },
        "REGEX_PATTERN": {
          "LABEL": "Шаблон регулярного выражения",
          "PLACEHOLDER": "Пожалуйста, введите шаблон регулярного выражения для пользовательского атрибута. (Опционально)"
        },
        "REGEX_CUE": {
          "LABEL": "Подсказка регулярного выражения",
          "PLACEHOLDER": "Пожалуйста, введите подсказку для шаблона регулярного выражения. (Опционально)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Включить проверку регулярных выражений"
        },
        "BADGES": {
          "PRE_CHAT": "Пре-чат",
          "RESOLUTION": "Завершение диалога"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Пользовательский атрибут успешно добавлен!",
        "ERROR_MESSAGE": "Не удалось создать пользовательский атрибут. Пожалуйста, повторите попытку позже."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Пользовательский атрибут успешно удалён.",
        "ERROR_MESSAGE": "Невозможно удалить пользовательский атрибут. Попробуйте ещё раз."
      },
      "CONFIRM": {
        "TITLE": "Вы уверены, что хотите удалить - {attributeName}",
        "PLACE_HOLDER": "Пожалуйста, введите {attributeName} для подтверждения",
        "MESSAGE": "Удаление приведет к окончательному удалению атрибута",
        "YES": "Удалить ",
        "NO": "Отменить"
      }
    },
    "EDIT": {
      "TITLE": "Редактирование пользовательского атрибута",
      "UPDATE_BUTTON_TEXT": "Обновить",
      "TYPE": {
        "LIST": {
          "LABEL": "Список значений",
          "PLACEHOLDER": "Пожалуйста, введите значения и нажмите клавишу Enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Пользовательский атрибут успешно обновлен",
        "ERROR_MESSAGE": "Произошла ошибка при обновлении пользовательского атрибута, пожалуйста, попробуйте еще раз"
      }
    },
    "TABS": {
      "HEADER": "Пользовательские атрибуты",
      "CONVERSATION": "Диалог",
      "CONTACT": "Контакт",
      "COMPANY": "Компания"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Имя",
        "DESCRIPTION": "Описание",
        "TYPE": "Тип",
        "KEY": "Ключ"
      },
      "BUTTONS": {
        "EDIT": "Редактировать",
        "DELETE": "Удалить"
      },
      "EMPTY_RESULT": {
        "404": "Нет созданных пользовательских атрибутов",
        "NOT_FOUND": "Нет настроенных пользовательских атрибутов"
      },
      "REGEX_PATTERN": {
        "LABEL": "Шаблон регулярного выражения",
        "PLACEHOLDER": "Пожалуйста, введите шаблон регулярного выражения для пользовательского атрибута. (Опционально)"
      },
      "REGEX_CUE": {
        "LABEL": "Подсказка регулярного выражения",
        "PLACEHOLDER": "Пожалуйста, введите подсказку для шаблона регулярного выражения. (Опционально)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Включить проверку регулярных выражений"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Пре-чат",
      "RESOLUTION": "Завершение диалога"
    }
  }
}
